var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12","md":"12","lg":"12","xl":"12"}},[_c('TitleAndSearch',{attrs:{"icon":'icon_create_report',"title":'Generación de Informe',"showSearch":true}}),_c('CreateReport')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }